import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import WalletList from "./WalletList";

import { batchedApolloClient } from "app/utils/graphQlClients";

type Props = {
  external_reference: string;
};

export default graphql<any, Props>(
  gql`
    query wallets($external_reference: ID) {
      user(external_reference: $external_reference) {
        wallet_user {
          wallet_wallets {
            name
            display_name
            balance
          }
        }
      }
    }
  `,
  {
    options: props => ({
      fetchPolicy: "network-only",
      client: batchedApolloClient,
      variables: {
        external_reference: props.external_reference
      }
    })
  }
)(props => (
  <BOGraphQLLoader data={props.data!}>
    <WalletList
      wallets={
        (props.data.user &&
          props.data.user.wallet_user &&
          props.data.user.wallet_user.wallet_wallets) ||
        []
      }
    />
  </BOGraphQLLoader>
));
